/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/div.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Divide one value by another. For numeric operands, if either field is multivalued
 * then the result is `null`.
 *
 * Note: Division of two integer types will yield an integer result, rounding towards 0. "
 * If you need floating point division, `Cast (::)` one of the arguments to a `DOUBLE`.
 * For dense_vector operations, both arguments should be dense_vectors. Inequal vector dimensions generate null result.
 *
 */
const definition: OperatorDefinition = {
  operator: '/',
  name: 'div',
  titleName: 'divide',
  signatures: [
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'double',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'integer',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'rhs',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'unsigned_long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
